/* eslint-disable import/prefer-default-export */
import { actions } from './slice';

const { toggleThemeMode } = actions;

export { toggleThemeMode };
